// extracted by mini-css-extract-plugin
export default {"marginBottom":"H4Nl6i","weightFormHint":"d1wdUx","input":"j82Q5X","targetWeightFormHint":"WLAleD","frontLabel":"hJ6KET","inputContainer":"OKkdht"};